var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCloseIcon = function SvgCloseIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8889 0.5H2.11111C1.55121 0.5 1.01424 0.72242 0.61833 1.11833C0.22242 1.51424 0 2.05121 0 2.61111V17.3889C0 17.9488 0.22242 18.4858 0.61833 18.8817C1.01424 19.2776 1.55121 19.5 2.11111 19.5H16.8889C17.4488 19.5 17.9858 19.2776 18.3817 18.8817C18.7776 18.4858 19 17.9488 19 17.3889V2.61111C19 2.05121 18.7776 1.51424 18.3817 1.11833C17.9858 0.72242 17.4488 0.5 16.8889 0.5ZM13.3 15.2778L9.5 11.4778L5.7 15.2778L4.22222 13.8L8.02222 10L4.22222 6.2L5.7 4.72222L9.5 8.52222L13.3 4.72222L14.7778 6.2L10.9778 10L14.7778 13.8L13.3 15.2778Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close-icon.d0b4f2a2.svg";
export { ForwardRef as ReactComponent };